import { Gauge } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PolicyField } from "./PolicyField";
import type { PolicyCardProps } from "./policy-card.types";

// Spec 079 — as CORES do OEE. Decidem o painel inteiro, e também o diagnóstico que o explica:
// o limiar verde é o mesmo número que aponta "Disponibilidade é o componente menor".
export function OeeThresholdsCard({ register, errors, disabled }: PolicyCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Gauge className="h-4 w-4 text-text-tertiary" aria-hidden />
          Cores do OEE
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 sm:grid-cols-2">
        <PolicyField
          id="policy-oee-good"
          label="Limiar verde"
          unit="%"
          hint="A partir dele o indicador aparece em verde no painel, e o diagnóstico deixa de apontar um componente como o menor. Precisa ser maior que o amarelo."
          registration={register("oeeThresholdGood", { valueAsNumber: true })}
          error={errors.oeeThresholdGood}
          disabled={disabled}
          step="0.01"
        />
        <PolicyField
          id="policy-oee-warn"
          label="Limiar amarelo"
          unit="%"
          hint="Entre ele e o verde o indicador aparece em amarelo; abaixo dele, em vermelho."
          registration={register("oeeThresholdWarn", { valueAsNumber: true })}
          error={errors.oeeThresholdWarn}
          disabled={disabled}
          step="0.01"
        />
      </CardContent>
    </Card>
  );
}
